import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-ship-carferry')
export class ObiShipCarferry extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.5 11H22L20.2778 14.4443C19.8396 14.3769 19.4059 14.2491 18.9878 14.0645C18.6879 13.9353 17.9996 13.5073 17.9996 13.5073C17.9996 13.5073 17.3086 13.9292 17.0086 14.0584C15.7161 14.6143 14.2808 14.6138 12.9885 14.0572C12.6885 13.928 12.0002 13.5 12.0002 13.5C12.0002 13.5 11.3115 13.928 11.0115 14.0572C9.71724 14.6147 8.27971 14.6143 6.98565 14.056C6.6857 13.9268 6.00021 13.5 6.00021 13.5C6.00021 13.5 5.31167 13.9313 5.01172 14.0605C4.59133 14.2471 4.16178 14.3762 3.72207 14.4442L2 11H8.5L10 9H11V8H13V9H14L15.5 11ZM10.5 10H13.5L14.25 11H9.75L10.5 10Z" fill="currentColor"/>
<path d="M18 17.25C18.94 17.75 19.97 18 21 18H22V16H21C20.3196 16 19.6348 15.8502 18.9878 15.5645C18.6879 15.4353 17.9996 15.0073 17.9996 15.0073C17.9996 15.0073 17.3086 15.4292 17.0086 15.5584C15.7161 16.1143 14.2809 16.1139 12.9885 15.5572C12.6885 15.428 12.0002 15 12.0002 15C12.0002 15 11.3115 15.428 11.0115 15.5572C9.71724 16.1147 8.27971 16.1143 6.98565 15.556C6.6857 15.4268 6.00021 15 6.00021 15C6.00021 15 5.31167 15.4313 5.01172 15.5605C4.36216 15.8488 3.68364 16 3 16H2V18H3C4.03 18 5.05 17.75 6 17.25C7.89 18.25 10.11 18.25 12 17.25C13.89 18.25 16.11 18.25 18 17.25Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.5 11H22L20.2778 14.4443C19.8396 14.3769 19.4059 14.2491 18.9878 14.0645C18.6879 13.9353 17.9996 13.5073 17.9996 13.5073C17.9996 13.5073 17.3086 13.9292 17.0086 14.0584C15.7161 14.6143 14.2808 14.6138 12.9885 14.0572C12.6885 13.928 12.0002 13.5 12.0002 13.5C12.0002 13.5 11.3115 13.928 11.0115 14.0572C9.71724 14.6147 8.27971 14.6143 6.98565 14.056C6.6857 13.9268 6.00021 13.5 6.00021 13.5C6.00021 13.5 5.31167 13.9313 5.01172 14.0605C4.59133 14.2471 4.16178 14.3762 3.72207 14.4442L2 11H8.5L10 9H11V8H13V9H14L15.5 11ZM10.5 10H13.5L14.25 11H9.75L10.5 10Z" style="fill: var(--element-active-color)"/>
<path d="M18 17.25C18.94 17.75 19.97 18 21 18H22V16H21C20.3196 16 19.6348 15.8502 18.9878 15.5645C18.6879 15.4353 17.9996 15.0073 17.9996 15.0073C17.9996 15.0073 17.3086 15.4292 17.0086 15.5584C15.7161 16.1143 14.2809 16.1139 12.9885 15.5572C12.6885 15.428 12.0002 15 12.0002 15C12.0002 15 11.3115 15.428 11.0115 15.5572C9.71724 16.1147 8.27971 16.1143 6.98565 15.556C6.6857 15.4268 6.00021 15 6.00021 15C6.00021 15 5.31167 15.4313 5.01172 15.5605C4.36216 15.8488 3.68364 16 3 16H2V18H3C4.03 18 5.05 17.75 6 17.25C7.89 18.25 10.11 18.25 12 17.25C13.89 18.25 16.11 18.25 18 17.25Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-ship-carferry': ObiShipCarferry;
  }
}
